// TXT brand palette
export const TXT_BLUE = '#0077b8';
export const TXT_TEAL = '#00b1b0';
export const TXT_ORANGE = '#f05a22';
export const TXT_NAVY = '#243841';
export const TXT_LIGHT_BLUE = '#00adef';
export const TXT_GREEN = '#8dc63f';
export const TXT_YELLOW = '#ffc50a';
export const TXT_RED = '#db4128';
export const TXT_GRAY_500 = '#919ba0';
export const TXT_GRAY_200 = '#d3d7d9';

// Semantic tokens
export const BRAND_PRIMARY = TXT_BLUE;
export const BRAND_ACCENT = TXT_ORANGE;
export const BRAND_BACKGROUND_ANIMATION = TXT_ORANGE;
export const BRAND_INFO = TXT_LIGHT_BLUE;
export const BRAND_SUCCESS = TXT_GREEN;
export const BRAND_WARNING = TXT_YELLOW;
export const BRAND_DANGER = TXT_RED;
export const BRAND_TEXT_PRIMARY = TXT_NAVY;
export const BRAND_TEXT_MUTED = TXT_GRAY_500;
export const BRAND_BORDER = TXT_GRAY_200;
export const BRAND_SURFACE = '#ffffff';

// Typography tokens (web/screen guidance)
export const FONT_HEADING = "'Open Sans', Arial, sans-serif";
export const FONT_BODY = "'Open Sans', Arial, sans-serif";

// Backward-compatible aliases used across app
export const COLOR_PRIMARY = BRAND_PRIMARY;
export const COLOR_LIGHT_BLUE = BRAND_INFO;
export const COLOR_BLACK = '#282828';
export const COLOR_SECONDARY = BRAND_ACCENT;
export const COLOR_RED = '#D72A16';
export const COLOR_GREEN = '#4caf50';
export const COLOR_GREY = '#f7f7fa';
export const COLOR_GOLD = '#fcba02';
export const COLOR_TEXT = '#1e1e1e';

export const TAG_COLOR_BLUE = COLOR_PRIMARY;
export const TAG_COLOR_GREEN = COLOR_GREEN;
export const TAG_COLOR_RED = COLOR_RED;
export const TAG_COLOR_ORANGE = BRAND_ACCENT;

// Txt-merch theme tokens (from txt_merch_roadmap_team.html)
export const MERCH_PRIMARY = '#1D9E75';
export const MERCH_PRIMARY_DARK = '#0F6E56';
export const MERCH_PRIMARY_BG = '#E1F5EE';
export const MERCH_PRIMARY_BG_LIGHT = '#f0faf6';
export const MERCH_PRIMARY_BORDER = '#9FE1CB';
export const MERCH_REVENUE_GREEN = '#0F6E56';
